<template>
  <section class="row">
    <div class="col-12">
      <div class="card">
        <div
          class="card-body py-md-4 pt-4 rounded-4 transition-shadow
            box-shadow-pink-300 box-shadow-hover-pink-300"
        >
          <div class="row">
            <div class="col-2">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-8">
              <div class="h5 text-center mb-3">
                Mes entreprises
              </div>
            </div>
            <div
              class="col-12 col-md-10 mx-auto"
              :class="{ 'my-4': allCompanies.length > 0 }"
            >
              <transition-group name="flip-list">
                <v-account-company-display
                  v-for="company in allCompanies"
                  :key="company.id"
                  :company="company"
                  class="mb-3"
                  @error="(value) => error = value"
                />
              </transition-group>
            </div>
            <div class="col-12 col-lg-6 mb-3 col-md-10 mx-auto">
              <v-loader
                :next="() => $router.push('/client/account/companies/add')"
                title="Ajouter une entreprise"
                icon="plus-white"
                class="w-100"
                disabled
              />
            </div>
            <br>
            <div class="col-12 col-lg-6 mb-3 col-md-10 mx-auto">
              <v-loader
                :next="() => $router.push('/client/accounts')"
                title="Changer d'entreprise"
                icon="back"
                class="w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import AccountCompanyDisplay from '../helpers/AccountCompanyDisplay.vue';

export default {
  name: 'AccountCompanies',
  components: {
    'v-account-company-display': AccountCompanyDisplay,
  },
  computed: {
    ...mapGetters({
      company: 'company/get',
      additionalCompanies: 'client/additionalCompanies',
    }),
    allCompanies() {
      const allCompanies = [];
      allCompanies.push(this.company);
      if (this.additionalCompanies && this.additionalCompanies.length > 0) {
        for (let i = 0; i < this.additionalCompanies.length; i += 1) {
          allCompanies.push(this.additionalCompanies[i]);
        }
      }

      return allCompanies;
    },
  },
};
</script>
